import React from 'react';
import useTranslation from 'next-translate/useTranslation';

import { numberSpliter } from '@/constants/helper';
import { Delivery } from '@/components/SvgComponents/Delivery';
import { freeDeliveryPrice } from '@/constants/base';

import Button from '../Button/Button';

import styles from './YourNumberList.module.scss';

const YourNumberListItem = ({ data, onClick, detail, isEsim }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`${styles.item} ${!isEsim && styles.item__sim}`}
      itemScope
      itemType='http://schema.org/ListItem'
    >
      <div className={styles.left_side}>
        {data?.levelName && (
          <>
            {isEsim ? (
              <span className={`${styles.type} ${!isEsim && styles.type__sim}`}>
                {(data.levelName === 'Simple'
                  ? 'Simple 55'
                  : data.levelName
                )?.replace('Simple', t('common:simple'))}
              </span>
            ) : (
              <div className={styles.simLabels}>
                <span
                  className={`${styles.type} ${!isEsim && styles.type__sim}`}
                >
                  {data?.levelName === 'Simple'
                    ? t('common:simple')
                    : data?.levelName}
                </span>
                {/* {data?.price >= freeDeliveryPrice && (
                  <div className={styles.rectangle}>
                    <span
                      className={`${styles.type} ${
                        !isEsim && styles.type__sim__monthly
                      }`}
                    >
                      <img src='/assets/birbankLogo.png' /> 24 ay taksitlə
                    </span>
                  </div>
                )} */}
                {data?.price >= freeDeliveryPrice && (
                  <div
                    className={`${styles.rectangle__freeDelivery} ${styles.rectangle}`}
                  >
                    <span
                      className={`${styles.type} ${
                        !isEsim && styles.type__sim
                      }`}
                    >
                      <Delivery />
                      {t('numbersale:freeDelivery')}
                    </span>
                  </div>
                )}
              </div>
            )}
          </>
        )}
        {data?.msisdn && data?.prefix && (
          <div className={styles.number}>
            <span className={styles.selected}>0{data?.prefix}</span>
            <span>{numberSpliter(data?.msisdn)}</span>
          </div>
        )}
        {!isEsim && (
          <div className={styles.simLabelsMobile}>
            {/* {data?.price >= freeDeliveryPrice && (
              <div
                className={`${styles.rectangle__birbank} ${styles.rectangle}`}
              >
                <span
                  className={`${styles.type} ${
                    !isEsim && styles.type__sim__monthly
                  }`}
                >
                  <img src='/assets/birbankLogo.png' /> 24 ay taksitlə
                </span>
              </div>
            )} */}

            {data?.price >= freeDeliveryPrice && (
              <div
                className={`${styles.rectangle__freeDelivery} ${styles.rectangle}`}
              >
                <span
                  className={`${styles.type} ${!isEsim && styles.type__sim}`}
                >
                  <Delivery />
                  {t('numbersale:freeDelivery')}
                </span>
              </div>
            )}
          </div>
        )}
      </div>
      <div className={`${styles.info} ${!isEsim && styles.info__sim}`}>
        <span>
          {data?.price ? (
            <div>
              <span className={styles.price}>{data?.price} ₼</span>
              {/* <Currency width={20} /> */}
            </div>
          ) : (
            <span className={styles.price}> {t('esim:common.free')}</span>
          )}
        </span>
        <Button
          className={styles.button}
          variant={'transparent'}
          onClick={() => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            onClick(data);
          }}
        >
          {detail?.order_button_text ?? t('numbersale:orderNumber')}
        </Button>
      </div>
    </div>
  );
};

export default YourNumberListItem;
